module.exports = __webpack_public_path__ + "static/media/sn.7439e079.svg";